import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import {Header, Body, Footer, Title} from 'react-bootstrap/lib/Modal'
import * as actions from './reducer';
import Window from './Window';

export default class ModalWindow extends Window
{
	constructor(title, text, buttons, style) {
		super(title, text, style);
		this.buttons = buttons;
		this.animation = true;
		this.dispatch = null;
		this.onBackKeyDownListener = this.onBackKeyDown.bind(this);
	}

	dispatchWindow(dispatch, modal) {
		this.dispatch = dispatch;
		this.modal = modal;
		dispatch(actions.openModal(this.modal));
	}

	hide() {
		this.dispatch(actions.closeModal(this.modal));
		document.removeEventListener("backbutton", this.onBackKeyDownListener);
	}

	handleClick(e) {
		if (__MOBILE__) {
			window.plugins.deviceFeedback.acoustic();
		}
	}

	onBackKeyDown() {
		this.hide();
	}

	show(dispatch = this.dispatch) {
		document.addEventListener("backbutton", this.onBackKeyDownListener);

		const modal = <Modal className={this.className}
							  animation={this.animation}
							  show={true}
							  onHide={() => this.hide()}
							  bsStyle={this.style}>
			<Header closeButton  onClick={(e) => this.handleClick(e)}>
				<Title>{this.title}</Title>
			</Header>
			<Body  onClick={(e) => this.handleClick(e)}>
				{React.cloneElement(this.text, {close:() => this.hide()})}
			</Body>
			{this.buttons &&
				<Footer  onClick={(e) => this.handleClick(e)}>
					{this.buttons}
				</Footer>
			}
		</Modal>;
		this.dispatchWindow(dispatch, modal);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-modal/src/ModalWindow.js